

import React, { useState, useMemo } from "react";
import PowerBIReport from "./PowerBIReport";
import legacyConfigProd from "./LegacyConfig.json";
import legacyConfigDev from "./LegacyConfig-Dev.json";

interface File {
  name: string;
  visualName: string | string[]; 
  pageName: string;
  workspaceId: string;
  reportId: string;
}

interface Folder {
  name: string;
  files: File[];
}

const LegacyReport: React.FC = () => {
  const [selectedFolder, setSelectedFolder] = useState<string | null>(null);
  const [selectedReport, setSelectedReport] = useState<File | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");


const legacyConfig = (process.env.REACT_APP_POWER_BI_ENV === 'prd')
? legacyConfigProd
: legacyConfigDev;

const filteredFolders = useMemo(() => {
return legacyConfig.folders.filter((folder: Folder) => {
  const matchesFolder = folder.name.toLowerCase().includes(searchTerm.toLowerCase());
  const matchesFile = folder.files.some((file: File) =>
    file.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return matchesFolder || matchesFile;
});
}, [searchTerm, legacyConfig]);

 
  const handleFolderClick = (folderName: string) => {
    setSelectedFolder((prev) => (prev === folderName ? null : folderName));
  };

  const handleReportClick = (file: File) => {
    setSelectedReport(null); 
    setTimeout(() => setSelectedReport(file), 100); 
  };

  return (
    <div>
      <div className="flex justify-between items-center mx-10 mt-10 font-poppins">
        {/* <h1 className="text-2xl font-bold text-gray-700 mb-4">Legacy Reports</h1> */}
        <h1 className="text-2xl font-bold text-gray-700 mb-4">
      Custom Reports 
      {selectedFolder && selectedReport && (
        <span className="text-sm text-gray-700 mb-4 ml-2">
          - {selectedReport.name}
        </span>
        )}
        </h1>
      </div>
      <div className="flex p-4 bg-[#EAE7FF] gap-4 max-h-full min-h-[800px] ml-10 mr-10 mb-4 rounded-lg flex-col md:flex-row">
        {/* Left Sidebar: Power BI Report */}
        <div className="flex-1 bg-white border border-gray-300 rounded-lg shadow-md p-4 flex flex-col font-poppins">
          <div className="flex-1 bg-gray-50 p-4 border border-gray-300 rounded-lg overflow-auto max-h-[750px] max-w-full">
            
            {selectedReport ? (
              <PowerBIReport
                key={selectedReport.reportId}
                workspaceId={selectedReport.workspaceId}
                reportId={selectedReport.reportId}
                pageName={selectedReport.pageName}
              />
            ) : (
              <div className="text-gray-400">Click on a report file to view details.</div>
            )}


          </div>
        </div>

        {/* Right Sidebar: Folder Selection */}
        <div className="w-full md:w-1/5 bg-white border border-gray-300 rounded-lg shadow-md p-4">
          <div className="bg-gray-100 text-gray-700 text-lg font-semibold px-4 py-2 rounded-lg mb-4">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search reports"
              className="w-full h-10 pl-4 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
            />
          </div>
          <ul className="list-none p-0">
            {filteredFolders.map((folder) => (
              <li key={folder.name}>
                <div className="flex items-center gap-2 py-1">
                  <label
                    className="flex items-center text-gray-700 text-sm cursor-pointer"
                    onClick={() => handleFolderClick(folder.name)}
                  >
                    <i className="fas fa-folder text-violet-500 mr-2"></i>
                    {folder.name}
                  </label>
                </div>
                {selectedFolder === folder.name && (
                  <ul className="pl-6">
                    {folder.files.map((file) => (
                      // <li
                      //   key={file.name}
                      //   className="cursor-pointer text-sm text-gray-600 hover:text-violet-500"
                      //   onClick={() => handleReportClick(file)} 
                      // >
                                          <li
                      key={file.name}
                      className={`cursor-pointer text-sm transition ${
                        selectedReport?.name === file.name 
                          ? "text-violet-500 font-medium"  // Highlight selected file
                          : "text-gray-600 hover:text-violet-500"
                      }`}
                      onClick={() => handleReportClick(file)}
>
                        <i className="fas fa-file-alt text-gray-500 mr-2"></i>
                        {file.name}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LegacyReport;

